import { createAction } from '@reduxjs/toolkit'
import { User } from '../../../types/api'
import { RegisterData } from './types'

/**
 * Actions do módulo Auth
 */
export const authActions = {
  // Check Auth (verificar se usuário está autenticado ao carregar)
  checkAuthRequest: createAction('auth/checkAuthRequest'),
  checkAuthSuccess: createAction<{ user: User; token: string }>('auth/checkAuthSuccess'),
  checkAuthFailure: createAction('auth/checkAuthFailure'),
  
  // Login
  loginRequest: createAction<{ emailOrCpf: string; password: string }>('auth/loginRequest'),
  loginSuccess: createAction<{ user: User; token: string }>('auth/loginSuccess'),
  loginFailure: createAction<{ error: string }>('auth/loginFailure'),
  
  // Logout
  logoutRequest: createAction('auth/logoutRequest'),
  logoutSuccess: createAction('auth/logoutSuccess'),
  logoutFailure: createAction<{ error: string }>('auth/logoutFailure'),
  
  // Register
  registerRequest: createAction<RegisterData>('auth/registerRequest'),
  registerSuccess: createAction<{ user: User; token: string }>('auth/registerSuccess'),
  registerFailure: createAction<{ error: string }>('auth/registerFailure'),
  clearRegisterResult: createAction('auth/clearRegisterResult'),
  
  // Get Me (buscar dados atualizados do usuário)
  getMeRequest: createAction('auth/getMeRequest'),
  getMeSuccess: createAction<{ user: User }>('auth/getMeSuccess'),
  getMeFailure: createAction<{ error: string }>('auth/getMeFailure'),
  
  // Update User (atualizar dados do usuário localmente)
  updateUser: createAction<Partial<User>>('auth/updateUser'),
  
  // Clear Error
  clearError: createAction('auth/clearError'),
}

